import { render } from "./Separata.vue?vue&type=template&id=a4eb0c3a&scoped=true"
import script from "./Separata.vue?vue&type=script&lang=js"
export * from "./Separata.vue?vue&type=script&lang=js"

import "./Separata.vue?vue&type=style&index=0&id=a4eb0c3a&scoped=true&lang=scss"

import exportComponent from "/srv/http/cv.mzubiaga.net/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4eb0c3a"]])

export default __exports__